import { memo } from 'react';
import styled, { css } from 'styled-components';
import { spacing, colors } from '@izettle/otto';
import { IconButton } from '../icon-button/index.js';

const mixinHover = _ref => {
  let {
    searchStyle
  } = _ref;
  return searchStyle ? css`
        color: ${colors.icon.default};
        background: none;
      ` : "";
};
const getIconColor = _ref2 => {
  let {
    color = "default"
  } = _ref2;
  const isObject = typeof colors.icon[color] === "object" && Object.prototype.hasOwnProperty.call(colors.icon[color], "small");
  return isObject ? colors.icon[color].small : colors.icon[color];
};
const InputButtonGeneric = /*#__PURE__*/memo(styled(IconButton).withConfig({
  displayName: "styles__InputButtonGeneric",
  componentId: "zettle__sc-49eozk-0"
})(["color:", ";font-size:24px;display:flex;align-items:center;background:none;border:none;transition:color 0.1s cubic-bezier(0.25,0.1,0.25,1);margin-right:", ";outline:none;&:hover{", "}"], getIconColor, spacing.small, mixinHover));
const InputButtonGenericContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__InputButtonGenericContainer",
  componentId: "zettle__sc-49eozk-1"
})(["height:100%;display:flex;align-items:center;"]);

export { InputButtonGeneric, InputButtonGenericContainer };
//# sourceMappingURL=styles.js.map
